import React, { useState, useEffect, useContext } from "react";

import TableMainSearch from "../../common/MainSearch";
import MainBodyTabs from "../financeTabs";
import MainTitle from "../../common/MainTitle";
import DataTable from "./PastBalancesList";

import db from "../../../services/query";
import MainPrintLink from "../../common/MainPrint";

const PastBalancesByFaculties = (props) => {
  const [data, updateData] = useState([]);
  const [query, setQuery] = useState("");

  const routeTabs = [
    {
      name: "مصرف ها",
      path: "/mis/expenses/1",
    },
    {
      name: "بودجه ها",
      path: "/mis/expenseBudgets",
    },
    {
      name: "طرف های قرارداد",
      path: "/mis/contractors",
    },
    {
      name: "حسابات قبلی استادان",
      path: "/mis/facultiesPastBalance",
    },
    {
      name: "امتیازات استادان",
      path: "/mis/teacherBenefits",
    },
  ];

  useEffect(() => {
    const ac = new AbortController();

    requestData();

    return () => ac.abort();
  }, []);

  const requestData = async () => {
    try {
      let query = `expenses/salary/faculties/balances`;

      await db.getAll(query).then(({ data }) => {
        updateData(data);
      });
    } catch ({ response }) {
      updateData(response);
    }
  };

  return (
    <div className="main-content">
      <div className="main-content-header">
        <div className="right-content">
          <MainTitle title={"حسابات قبلی استادان"} />
        </div>
        <div className="center-content">
          <TableMainSearch setQuery={setQuery} />
        </div>
        <div className="left-content">
          <MainPrintLink path={"facultiesPastBalance"} />
        </div>
      </div>
      <div className="main-content-body">
        <MainBodyTabs tabs={routeTabs} {...props} />
        <DataTable data={data} {...props} query={query} />
      </div>
    </div>
  );
};

export default PastBalancesByFaculties;
